// extracted by mini-css-extract-plugin
export default {"footer":"Pie_footer__4ZK69"};